import { getItem, logout } from "./Utils";
import { toast } from "react-toastify";
import { convertSnakeToCamelCase } from "./Utils";

const API_BASE_URL = "https://api.fluvo.ai/Fluvo/";

export const IS_TEST_MODE = true;

export function getOptionalSessionId() {
  return getItem("sessionid") || null;
}

export async function apiCall({
  endpoint,
  method = "POST",
  headers = {},
  body = null,
  authRequired = true,
  ...otherOptions
} = {}) {
  let url = `${API_BASE_URL}${endpoint}`;
  const sessionId = authRequired ? getItem("sessionid") : null;

  // Check authentication if required
  if (authRequired) {
    if (!sessionId) {
      logout();
      toast.error("Session expired. Please log in again.");
      throw new Error("Session expired. Please log in again.");
    }
  }

  // Initialize body if it's null
  if (!body && method !== "GET") {
    body = {};
  }

  // Add sessionId to body for POST requests, or as query param for GET requests
  if (sessionId) {
    if (method === "GET") {
      const separator = endpoint.includes("?") ? "&" : "?";
      url += `${separator}sessionId=${encodeURIComponent(sessionId)}`;
      if (IS_TEST_MODE) {
        url += "&isTest=true";
      }
    } else {
      body = body || {};
      body.sessionid = sessionId;
    }
  }

  const config = {
    method,
    headers: {
      "Content-Type": "application/json",
      ...headers,
    },
    ...otherOptions,
  };

  // Add body if provided and method is not GET
  if (body && method !== "GET") {
    if (IS_TEST_MODE) {
      body.isTest = true;
    }
    config.body = JSON.stringify(body);
  }

  try {
    const response = await fetch(url, config);

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        errorData.message || `HTTP error! status: ${response.status}`
      );
    }

    const data = await response.json();
    console.log("data", convertSnakeToCamelCase(data));

    if (data.usererror) {
      throw new Error(data.usererror);
    }

    return convertSnakeToCamelCase(data);
  } catch (error) {
    console.error("API call failed:", error);
    toast.error(error.message || "Something went wrong. Please try again.");
    throw error;
  }
}
